import styles from './ProductCardPrice.module.scss';
import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { FontAwesomeProIcon, Heading } from '@wienenergiegithub/ui-next';
import { DialogDisclosure } from '@ariakit/react';

const ProductCardPrices = ({ priceItems }) =>
  priceItems.map(({ main_price: mainPrice, unit, subline }) => (
    <ProductCardPriceLegacy
      key={`${mainPrice}-${unit}-${subline}`}
      multiplePrices={priceItems.length > 1}
      price={mainPrice}
      unit={unit}
    />
  ));

const ProductCardPriceLegacy = ({
  small = false,
  multiplePrices,
  price,
  unit,
  additional,
  theme,
  withMore = null,
  contrast = false,
  subtextCenter = false,
}) => {
  const [animationState, setAnimationState] = useState(false);
  const initialRender = useRef(true);
  const isFirefox = typeof InstallTrigger !== 'undefined';
  const [ariaLabel, setAriaLabel] = useState({ live: '', atomic: '' });
  useEffect(() => {
    let timer = null;
    const animationDelay = isFirefox ? 50 : 10;
    // cardPriceSmall has always initialRender,
    // That's why it should be in this if condition
    if (initialRender.current && !small) {
      initialRender.current = false;
    } else {
      setAriaLabel({ live: 'polite', atomic: 'true' });
      if (animationState) {
        setAnimationState(false);
      }
      timer = setTimeout(() => {
        setAnimationState(true);
      }, animationDelay);
    }
    return () => clearTimeout(timer);
  }, [price]);
  return (
    <div
      aria-atomic={ariaLabel.atomic}
      aria-live={ariaLabel.live}
      className={classNames(
        styles.cardPriceContainer,
        {
          [styles.multiplePrices]: multiplePrices,
          [styles.contrast]: contrast,
          [styles.priceAnimation]: animationState,
          'big-entrance-animation': animationState,
        },
        styles[theme],
      )}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
    >
      <div className={styles.cardPriceWrapper}>
        <Heading
          as="h3"
          className={classNames(styles.cardPrice, {
            [styles.cardPriceSmall]: small,
            [styles.highlight]: theme === 'highlight',
            [styles.priceAnimation]: animationState,
            'big-entrance-animation': animationState,
          })}
          noSpacing
          size="h1"
        >
          {price} {small && unit}
        </Heading>
        {!small && <span className={styles.cardPriceUnit}>{unit}</span>}
        {withMore && (
          <DialogDisclosure
            aria-label="Mehr Informationen über den Preis"
            className={styles.informationButton}
            store={withMore}
          >
            <FontAwesomeProIcon
              className={styles.priceMoreIcon}
              fixedWidth
              icon="info-circle"
              role="presentation"
              size="2x"
              type="regular"
            />
          </DialogDisclosure>
        )}
      </div>
      <div
        className={classNames({ [styles.subline]: subtextCenter })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: additional }}
      />
    </div>
  );
};

export default ProductCardPriceLegacy;
export { ProductCardPrices };
